import { Resource } from '@lagoshny/ngx-hateoas-client';
import { MetaData } from './meta-data.model';

export class BaseObject extends Resource {
  public id!: string;
  public _revision!: string;
  public _metadata!: Metadata;
}

export class Metadata extends MetaData {
  public make?: string;
  public model?: string;
  public longitude?: number;
  public latitude?: number;
  public altitude?: number;
  public date?: Date | string;
  public width?: number;
  public height?: number;
}
